import { ConsumerSubscription } from "#/lib/carrot-api/types/ConsumerSubscription"

export const CONSUMER_REGISTRATION_RESUME_PATH = "/consumer/register/resume"

// Only external storefronts go back to the funnel: a carrot member who is registration_incomplete has
// already paid and is waiting on the subscription sync.
export function shouldResumeExternalRegistration(subscription: ConsumerSubscription | null | undefined): boolean {
  return subscription?.storefront.type === "external" && subscription.state === "registration_incomplete"
}
